import requestUtils from 'api/requestUtils'

interface RequestParams {
  businessId: string
}

interface RequestPayload {
  societe: {
    unlockTierDismissedAt?: string
    almostThereDismissedAt?: string
    completionDismissedAt?: string
  }
}

async function requestPatchEmployeeNotification(
  params: RequestParams,
  payload: RequestPayload,
) {
  await requestUtils.patch<null, RequestPayload>(
    `/api/business-traveller/businesses/${params.businessId}/employees/notification-state?without_brand=1`,
    payload,
    { credentials: 'include' },
  )
  return true
}

export default requestPatchEmployeeNotification
